import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=49e2f174&scoped=true"
import script from "./OrderListItem.vue?vue&type=script&lang=js"
export * from "./OrderListItem.vue?vue&type=script&lang=js"
import style0 from "./OrderListItem.vue?vue&type=style&index=0&id=49e2f174&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e2f174",
  null
  
)

export default component.exports